import { AssetCreationType, AssetFiltersType, AssetItem } from 'src/api/api-types/assets';
import * as yup from 'yup';

import { ColumnsVisibilityModel } from '../../../api/api-types/gridColumnsManager';
import { MMCompliance } from '../components/CreateActivity/type';
import { ItemType } from 'src/types';
import { ACCOUNT_TYPE_OBJECT, GENERATOR_TYPE_OBJECT } from 'src/utils/constants';

export const initialAssetsData: AssetCreationType = {
  shortText: '',
  client: { id: 0, name: '' },
  totalAttachments: 0,
  createdAt: new Date(),
  id: 0,
  description: '',
  dateIssued: new Date(),
};

const basicValidationConfig = {
  type: yup.mixed().label('Type').required(),
  relatedToType: yup.object().label('Related to').nullable(),
  relatedTo: yup.object().required().label('Related to').nullable(),
  dateIssued: yup
    .string()
    .label('Date issued')
    .nullable()
    .when('client', {
      is: (val: string) => val === '2' || val === '3',
      then: yup.string().required().typeError('Date issued to is required'),
    }),
  description: yup.string().label('Description').optional().max(100_000),
  category: yup
    .number()
    .required()
    .label('Category')
    .typeError('Category is required'),
};
export const validationSchema = yup
  .object({
    ...basicValidationConfig,
    subCategory: yup
      .string()
      .label('Sub-Category')
      .when('type', {
        is: (val: number | ItemType) => {
          const type = typeof val === 'object' ? val?.id : val; 
          return type === MMCompliance;
        },
        then: yup.string().required().typeError('Sub-Category is required'),
        otherwise: yup.string().optional().nullable(),
      }),
  })
  .required();

export const validationActivitySchema = yup
  .object({
    ...basicValidationConfig,
    relatedTo: yup.object().required().label('Link to').nullable(),
    subCategory: yup.string().required().label('Sub-Category').nullable(),
  })
  .required();

export const validationWaiverSchema = yup
  .object({
    ...basicValidationConfig,
    waiverInfoStatusId: yup
      .string()
      .required()
      .label('Waiver Status')
      .nullable(),
    subCategory: yup.string().required().label('Sub-Category').nullable(),
  })
  .required();

export const validationStandaloneWaiverSchema = yup
  .object({
    ...basicValidationConfig,
    relatedTo: yup.object().required().label('Link to').nullable(),
    waiverInfoStatusId: yup
      .string()
      .required()
      .label('Waiver Status')
      .nullable(),
    subCategory: yup.string().required().label('Sub-Category').nullable(),
  })
  .required();

export const validationIRSchema = yup
  .object({
    shortText: yup.string().label('Activity title').required(),
    description: yup.string().label('Description').optional().max(100_000),
  })
  .required();

export const defaultVisibilityColumns = {
  accountType: true,
  generator: true,
  createdAt: true,
  createdBy: true,
  description: true,
  shortText: true,
};

export const visibilityDefaultState: Partial<ColumnsVisibilityModel> = {
  admin: {
    jurisdiction: true,
    ...defaultVisibilityColumns,
  },
  hauler: {
    hauler: true,
    ...defaultVisibilityColumns,
  },
};

export const defaultAssetsSearch = {
  'q.reference': '',
  'q.jurisdiction.id': '',
  'q.generator.accountNumber': '',
  'q.generator.name': '',
  'q.generator.reference': '',
  'q.generator.usaAddress': '',
  'q.parentLocation.reference': '',
} as AssetFiltersType;

export const DEFAULT_POPUP_AREA_WIDTH = 380;

export const getRelatedIds = (row: AssetItem | null) => {
  const relatedToTypeId = row?.relatedToType?.id;
  const relatedToId = row?.relatedTo?.id;
  
  return {
    accountId: relatedToTypeId === ACCOUNT_TYPE_OBJECT.id ? relatedToId : undefined,
    generatorId: relatedToTypeId === GENERATOR_TYPE_OBJECT.id ? relatedToId : undefined,
  };
};